export const moduleName = 'userManagementModule';
